module.exports = __webpack_public_path__ + "img/sld_mfm_og_t1_b1_dark.af838add.svg";